import classNames from 'classnames';
import React from 'react';

import css from './cms-block-wrapper.css';

import type { PropsWithChildren } from 'react';

interface CMSBlockWrapperProps {
  className?: string;
  contentClassName?: string;
}

export const CMSBlockWrapper = ({
  children,
  className,
  contentClassName
}: PropsWithChildren<CMSBlockWrapperProps>) => {
  return (
    <div className={classNames(css.padding, className)}>
      <div className={classNames(css.container, contentClassName)}>{children}</div>
    </div>
  );
};
